
import {DatasetButton} from './DatasetButton.js'
import {isNil, isEmpty, find, propEq} from 'ramda'
import {useTCData, useTeams} from '../../context'

export const DatasetSelectDropdown = () => {
    const {tcData} = useTCData()
    const {team1, team2, setTeam1, setTeam2} = useTeams()
    
    const dataIsValid = (data) => {
        return !isNil(data) && !isEmpty(data) && data.length > 0
    }
    const updateTeams = (newData) => {
        setTeam1(team1.map(player => find(propEq(player.name, "name"), newData)))
        setTeam2(team2.map(player => find(propEq(player.name, "name"), newData)))
    }
    return (
        <center>
            {/* <div className="is-flex is-justify-content-center" style={{fontSize: ".8rem", margin: "0 7rem"}}>
                <div>The <b>Roto Value</b> is based on three year projection system with aging curves incorporated. It is based for a standard 15-team Roto league that uses a mix between OBP and AVG and other traditional hitting stats. On the pitching side, a focus on IP and Quality Starts are used over wins while also factoring in saves and holds. Tradition pitching stats such as ERA, Ks and WHIP are included.
                </div>
                </div>
                <div className="is-flex is-justify-content-center" style={{fontSize: ".8rem", margin: "0 7rem 2rem 7rem"}}>
                <div>The <b>Points</b> scoring value looks at total points scored over a three-year window using aging curves and projections. It uses a balanced scoring system. For hitters: TB: 1.25, BB: 1, K: -.5, SB: 3, R: 1, RBI .5, IBB: 1, HBP: 1, GDIP: -.5, CS: -1.5. For Pitchers: Quality Appearance: 5, BB: -.5, K: 1.25, SV: 7, IP: 2, HLD: 4, H: -.5, ER: -1.25, BS: -3. In future updates we plan to have a custom scoring setting where you can input your league scoring settings.
                </div>
                </div> */}
            <div><b>Select Team Type</b></div>
            <div className="is-flex is-justify-content-center is-align-items-center is-flex-direction-row is-flex-wrap-wrap" style={{marginBottom: "1rem"}}>
                {dataIsValid(tcData) && tcData.map((item, i) => <DatasetButton item={item} key={"Dataset Button" + i} updateTeams={updateTeams} />)}
            </div>
        </center>
    )
}


// {/* <div className={`dropdown ${isOpen?"is-active":""}`} onClick={() => setIsOpen(!isOpen)}>
// <div className="dropdown-trigger">
//     <button className="button" aria-haspopup="true" aria-controls="dropdown-menu">
//     <span>{dataSetName}</span>
//     <span style={{marginLeft: "5px"}}>x</span>
//     {/* <span className="icon is-small">
//         <i className="fas fa-angle-down" aria-hidden="true"></i>
//     </span> */}
//     </button>
// </div>
// <div className="dropdown-menu" id="dropdown-menu" role="menu">
//     <div className="dropdown-content" style={{maxHeight: "200px", overflow: "auto"}}>
//         {dataIsValid(allData) && allData.map((item, i) => <DatasetDropdownItem item={item} key={"Dropdown" + i} setData={setData} setDataSetName={setDataSetName} updateTeams={updateTeams} />)}    
//     </div> 
// </div>
// </div> 